import { config, library, dom } from "@fortawesome/fontawesome-svg-core"
import { faToggleOn, faToggleOff, faPenToSquare, faTrashCan, faCheck, faXmark, faImage, faChevronLeft, faChevronRight, faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons"

config.autoReplaceSvg = "nest" // Prevent icon duplication in Fullcalendar
library.add(faToggleOn, faToggleOff, faPenToSquare, faTrashCan, faCheck, faXmark, faImage, faChevronLeft, faChevronRight, faArrowUp, faArrowDown)
dom.watch()
